export const ItemTypes = {
  CARD: 'card',
}

export const STATUS_CODE = {
  DUPLICATE_NAME: 409,
}
